class Shadow {
  readonly appBar = "0px 4px 4px rgba(0, 0, 0, 0.06)";
  readonly paper = "0px 0.761905px 2.28571px 0.761905px rgba(0, 0, 0, 0.15);";
  readonly snackbarAlert =
    "0px 6.09524px 9.14286px 4.57143px rgba(0, 0, 0, 0.15), 0px 3.04762px 3.04762px rgba(0, 0, 0, 0.3);";
}

export default new Shadow();
